import { EventBus } from "overline";

const eb = new EventBus();

export default eb;
